import * as Xstate from "@xstate/react";
import { useCallback, useContext, useMemo } from "react";

import { GlobalContext } from "../../../../app/stateMachines/GlobalContext";
import { useAppSelector } from "../../../../redux/redux";
import { isNoteAuthor } from "./noteAuthor";

/** The signed-in person's user ids (this firm's row and the one found by email). */
export const useMyUserIds = (): string[] => {
  const { user } = useAppSelector((state) => state.appReducer);
  const { userInfoService } = useContext(GlobalContext);
  const [userInfoState] = Xstate.useActor(userInfoService);
  const { userInfoByEmail } = userInfoState.context;
  return useMemo(
    () =>
      [user?.id, userInfoByEmail?.id]
        .filter(Boolean)
        .map((id) => `${id}`.toLowerCase()),
    [user?.id, userInfoByEmail?.id],
  );
};

/** `canEdit(note)`: true only for the note's author (Roadmap 1870). */
export const useCanEditNote = () => {
  const myIds = useMyUserIds();
  return useCallback(
    (note?: { createdByUserId?: string | null } | null) =>
      isNoteAuthor(note?.createdByUserId, myIds),
    [myIds],
  );
};
